import { useEffect, useRef } from 'react';
import { useCurrentProfile } from './api';
import { useToast } from '@/components/ui/Toast';
import { celebrateLevelUp } from '@/lib/celebrations';
/**
 * Détecte quand profile.level augmente entre 2 renders et déclenche :
 *  - un toast "Level up !"
 *  - des confettis dans le coin haut-droit (vers l'avatar du header)
 *
 * Composant invisible — à monter une fois sous AppLayout.
 *
 * Subtilité : le profil est rechargé via TanStack Query après chaque
 * partie (invalidation par les hooks check_my_*). Donc level=N+1 arrive
 * naturellement quelques secondes après la soumission. On compare le
 * level courant à un ref pour ne déclencher qu'à la transition.
 */
export function LevelUpDetector() {
    const { data: profile } = useCurrentProfile();
    const { toast } = useToast();
    const previousLevelRef = useRef(null);
    useEffect(() => {
        if (!profile)
            return;
        const current = profile.level;
        const previous = previousLevelRef.current;
        // Premier hydration : on initialise le ref sans déclencher.
        if (previous === null) {
            previousLevelRef.current = current;
            return;
        }
        if (current > previous) {
            previousLevelRef.current = current;
            celebrateLevelUp();
            toast({
                tone: 'achievement',
                title: `Niveau ${current} atteint !`,
                description: previous === current - 1
                    ? 'Continue à enchaîner les parties pour grimper.'
                    : `Bond de ${current - previous} niveaux d'un coup, monstre.`,
            });
        }
        else if (current < previous) {
            // Cas dégradé (admin reset XP) — on aligne sans toast.
            previousLevelRef.current = current;
        }
    }, [profile, toast]);
    return null;
}
